/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';

import { SubtleLink } from 'src/styles';
import { overflowEllipsis } from 'src/styles/mixins';

export const DetailsList = styled.ul`
  list-style-type: none;
  padding-left: 0;
`;

export const DetailsListFooter = styled.div`
  /* Match ModalFooter styles */
  padding-top: ${gridSize() * 1.75}px;
  padding-bottom: ${gridSize() * 2.5}px;
`;

export const ListItem = styled.li`
  display: flex;
  align-items: center;

  & + & {
    margin-top: ${gridSize()}px;
  }
`;

export const ListItemAvatar = styled.div`
  /* Remove extra height from avatar wrapper: https://css-tricks.com/fighting-the-space-between-inline-block-elements/ */
  font-size: 0;
  margin-right: ${gridSize()}px;
`;

export const ListItemLink = styled(SubtleLink)`
  ${overflowEllipsis()};
  margin-left: ${gridSize()}px;
  margin-right: ${gridSize()}px;
`;

export const ListItemIcon = styled(SubtleLink)`
  flex-shrink: 0;
  margin-left: auto;

  /* Remove extra height from icon wrapper */
  display: flex;
`;
